// Dropdown toggles
function toggleDropdown(target)
{
    const dropdown = target.closest('.dropdown');
    dropdown.classList.toggle('active');

    const chevron = target.querySelector('.dropdown-toggle');
    chevron.classList.toggle('fa-chevron-up');
    chevron.classList.toggle('fa-chevron-down');
}

for (let node of document.querySelectorAll('.dropdown-label'))
{
    node.addEventListener('click', function(e)
    {
        const currentDropdown = e.currentTarget.closest('.dropdown');
        const wasActive = currentDropdown.classList.contains('active');

        // Close all existing that don't contain the current one
        const toggleables = [...document.querySelectorAll('.dropdown.active')]
            .filter(el => el === currentDropdown || !el.contains(currentDropdown))
            .map(toggleDropdown);

        // Open current if it wasn't
        if (!wasActive) toggleDropdown(e.currentTarget);
    });
}

// Header scrolling listener
const body = document.querySelector('body');
const siteHeader = document.getElementById('site-header');
const stickyHeader = document.getElementById('sticky-header');
let stickyHeaderBottom; // not determinable yet
const headerTop = document.querySelector('.header-bottom');
let mainHeader; // not appended to DOM yet

window.addEventListener('scroll', function(e)
{
    mainHeader = document.querySelector('main header');

    // check for page header sticky class
    if (window.scrollY > headerTop.getBoundingClientRect().bottom)
    {
        body.classList.add('scrolled');

        if (!stickyHeaderBottom)
            stickyHeaderBottom = stickyHeader.getBoundingClientRect().bottom;
    }
    else
        body.classList.remove('scrolled');

    if (!mainHeader) return;

    // check for header sticky class; 61 hardcoded is height of .product-header-short
    if ((mainHeader.getBoundingClientRect().bottom - 61) < stickyHeaderBottom)
        body.classList.add('body-scrolled');
    else
        body.classList.remove('body-scrolled');
});

// Sidebar opening listener
for (let node of document.querySelectorAll('.rilm-sidebar-title-toggle'))
{
    node.addEventListener('click', function(e)
    {
        const sidebar = e.currentTarget.closest('.rilm-sidebar');
        sidebar.classList.toggle('mobile-visible');

        // Chevron direction switch
        e.currentTarget.classList.toggle('fa-chevron-left');
        e.currentTarget.classList.toggle('fa-chevron-right');
    });
}
